import React, { useEffect, useRef } from "react";
import { map } from "lodash";
import { FormikErrors } from "formik";

export interface SummaryProps<T = any> {
	errors: FormikErrors<T>;
}

const Summary: React.FC<SummaryProps> = ({ errors }) => {
	const summaryRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		summaryRef.current?.focus();
	}, []);

	const errorClick = (e: any) => {
		e.preventDefault();
		const { href } = e.target;
		const id = href.substring((href.indexOf("#") as number) + 1, href.length);
		document.getElementById(id)?.focus();
	};

	return (
		<div className="summary-box" ref={summaryRef} role="group" tabIndex={-1}>
			<h3>There were some problems with the form</h3>
			<ul className="ta-left">
				{map(errors, (error, key) => {
					return (
						<li key={key}>
							<a href={`#${key}`} onClick={errorClick}>
								{(error as unknown) as React.ReactElement}
							</a>
						</li>
					);
				})}
			</ul>
		</div>
	);
};

export default Summary;
